import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateTalentJob } from "../../types/createJobSchema";

import { CreateJobResponse } from "../types/job.types";
import { createJobTalent } from "../services/job.services";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";

export const useCreateTalentJob = (options?: { onSuccess?: (data: CreateJobResponse) => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateTalentJob) => createJobTalent(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.jobDetails(data.id) });
      options?.onSuccess?.(data);
    },
  });
};
